// @ts-nocheck
/* Port of components/InfoNote.js (48 lines) — byte-identical yellow-tinted note banner. */
import React from 'react';
import { FiInfo } from 'react-icons/fi';

const InfoNote = ({ children, className = '', style = {} }: any) => {
  return (
    <div
      className={`d-flex align-items-start ${className}`}
      style={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '4px',
        padding: '12px 16px',
        marginTop: '15px',
        marginBottom: '15px',
        ...style,
      }}
    >
      <FiInfo
        style={{ color: '#856404', fontSize: '18px', marginRight: '12px', marginTop: '2px', flexShrink: 0 }}
      />
      <div style={{ color: '#856404', fontSize: '14px', lineHeight: '1.5', flex: 1 }}>{children}</div>
    </div>
  );
};

export default InfoNote;
